<form name="delivery"
      method="POST"
      #form="ngForm">
    <div class="m-t-10-s p-t-2-s">
        <div class="w-12 m-b-10 pos-relative">
            <span *ifSize="'S'"
                  class="pos-absolute p-l-3 col-13 c1">{{'Delivery Country' | translate}}</span>

            <input-wrap class="form-size-1">
                <select class="select b-col-4"
                        name="country"
                        [(ngModel)]="data.country_id"
                        (change)="submit()">
                    @for (country of countries | orderBy: ['name']; track country.code) {
                    <option [value]="country.code">{{country.name}}</option>
                    }
                </select>
                @if (status.busy && app.isPlatformBrowser) {
                <div class="fill select bg-col-w flex flex-justify-center flex-middle">
                    {{'Updating...' | translate}}
                </div>
                }
            </input-wrap>
        </div>
        <!-- Delivery details -->
        <div class="flex-column m-t-4-s m-b-7">
            @if (status.busy && app.isPlatformBrowser) {
            <span class="s2">{{'Updating...' | translate}}</span>
            } @else {
            @for (rate of rates; track $index) {
            <div class="flex m-b-3 m-b-6-s">
                <div class="w-4 s2">{{rate.title}}</div>
                <div class="w-6 flex-column p-l-1">
                    <span class="p2 p-b-1">
                        {{rate.lead_time}}
                    </span>
                    <span class="c1 col-13"
                          [innerHtml]="rate.description"></span>
                </div>
                @if (rate.price !== 0) {
                <price class="w-2 s2 right"
                       [value]="rate.price" />
                } @else if (rate.price === 0) {
                <div class="w-2 s2 right">{{'FREE' | translate}}</div>
                }
            </div>
            }
            }
            @if (!rates?.length && !status.busy) {
            <div>{{'There is no delivery available for your country' | translate}}</div>
            }
        </div>

        <div class="s1 m-b-2">{{'Returns information' | translate}}</div>
        <div class="p1">
            <span *iCms="'returnNote' of content"></span>&nbsp;
            <href [link]="content().returnLink">
                <span class="b-b b-col-11"
                      *iCms="'returnLinkText' of content">
                </span>
            </href>.
        </div>
    </div>
</form>